class ProductATCBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.product = document.querySelector(
      '[id^="MainProduct-"] .product-form__buttons'
    );
    this.form = this.querySelector("product-form");
    this.productBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.sectionLists = this.querySelectorAll(".section-links");
    this.sections = document.querySelectorAll("[data-section-name]");
    this.mobileCurrentSection = this.querySelector(".current-section");
    

    this.loadSections();
    this.createObservers();
    this.bindEvents();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  createObservers() {
    const sectionConfig = {
      rootMargin: "-45% 0px -55%"
    };

    const productConfig = {
      threshold: 0.5, //[0, .25, .5, .75, 1],
      rootMargin: "0px 0px -50px",
    };

    let productObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          requestAnimationFrame(this.hide.bind(this));
        }
      });
    }, productConfig);

    let sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        
        let section = entry.target;
        if (entry.intersectionRatio > 0) {
          this.sectionLists.forEach((list) =>
            list
              .querySelectorAll(".section-link.current")
              .forEach((el) => el.classList.remove("current"))
          );
          this.sectionLists.forEach((list) =>
            list
              .querySelector(
                `.section-link[href="#${section.parentElement.id}"`
              )
              .classList.add("current")
          );
          this.mobileCurrentSection.innerHTML = section.dataset.sectionName;
        }
      });
    }, sectionConfig);

    productObserver.observe(this.product);
    this.sections.forEach((section) => sectionObserver.observe(section));
  }

  loadSections() {
    const sections = this.sections;
    let links = "";

    sections.forEach((el) => {
      const name = el.dataset.sectionName;
      const id = el.parentElement.id;
      links += `<li><a href="#${id}" class="section-link text-sm font-medium">${name}</a></li>`;
    });

    this.sectionLists.forEach((sectionList) =>
      sectionList.insertAdjacentHTML("beforeend", links)
    );
  }

  bindEvents() {
    this.querySelectorAll(".section-links--mobile .section-link").forEach(
      (el) =>
        el.addEventListener("click", (evt) => {
          evt.target.closest("details[open]").removeAttribute("open");
        })
    );

    if (this.getAttribute("variants")) {
      const variants = this.parentElement.querySelector('[id^="variant-"]');

      variants.addEventListener("change", (evt) => {
        const current = variants.currentVariant;
        this.form.querySelector('input[name="id"]').value = current.id;
      });
    }
  }

  hide() {
    this.classList.add("atc-hidden");
  }

  reveal() {
    this.classList.remove("atc-hidden");
  }

  reset() {
    this.classList.add("atc-hidden");
  }
}

customElements.define("product-atc-bar", ProductATCBar);
